'use strict';

// Variables

const nav = document.querySelector('.header__nav');
const burger = document.querySelector('.header__burger');

const modal = document.querySelector('.modal');
const tabs = document.querySelectorAll('.modal__tab');
const texts = document.querySelectorAll('.modal__text');
const imgs = document
  .querySelector('.section-about__svg')
  .querySelectorAll('.section-about__img');

const heroBtn = document.querySelector('.cta__hero');
const headerNav = document.querySelector('.header__nav');

const header = document.querySelector('.header');
const hero = document.querySelector('.section-hero');

// Variables

// Modal window

modal.addEventListener('click', function (e) {
  const obj = e.target;
  const id = obj.dataset.index;

  if (!obj.classList.contains('modal__tab')) return;

  tabs.forEach((tab) => {
    tab.classList.remove('modal__active');
  });

  obj.classList.add('modal__active');

  texts.forEach((text) => {
    if (!text.classList.contains(`modal__text--${id}`)) {
      text.classList.remove('modal__text--active');
    }
    if (text.classList.contains(`modal__text--${id}`)) {
      text.classList.add('modal__text--active');
    }
  });

  imgs.forEach((img) => {
    if (!img.classList.contains(`section-about__img--${id}`)) {
      img.classList.remove('active');
    }
    if (img.classList.contains(`section-about__img--${id}`)) {
      img.classList.add('active');
    }
  });
});

// Smooth scroll

headerNav.addEventListener('click', (e) => {
  e.preventDefault();
  const el = e.target;
  if (!el.classList.contains('header__nav__link')) return;

  const id = e.target.getAttribute('href');

  burger.classList.toggle('burger-x');
  nav.classList.toggle('nav-open');

  if (document.body.getClientRects()[0].width <= 1400) {
    setTimeout(() => {
      document.querySelector(id).scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }, 500);
  } else {
    document.querySelector(id).scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  }
});

heroBtn.addEventListener('click', (e) => {
  e.preventDefault();
  const id = e.target.closest('.btn--hero').getAttribute('href');
  document
    .querySelector(id)
    .scrollIntoView({ behavior: 'smooth', block: 'start' });
});

// Sticky nav

const navHeight = header.getBoundingClientRect().height;

const toggleClass = function (entries) {
  const [entry] = entries;

  if (!entry.isIntersecting) header.classList.add('sticky');
  else header.classList.remove('sticky');
};

const headerObserver = new IntersectionObserver(toggleClass, {
  root: null,
  threshold: 0,
  rootMargin: `-${navHeight * 2}px`,
});

headerObserver.observe(hero);

// "Wejście" sekcji

const allSections = document.querySelectorAll('.section');

const revealSection = function (entries, observer) {
  const [entry] = entries;

  if (!entry.isIntersecting) return;

  entry.target.classList.add('section--reveal');
  entry.target.classList.remove('section');
  observer.unobserve(entry.target);
};

const sectionObserver = new IntersectionObserver(revealSection, {
  root: null,
  rootMargin: '200px',
});

allSections.forEach(function (section) {
  sectionObserver.observe(section);
  // section.classList.add('section--hidden');
});

// Spinner

const spinner = document.querySelector('.spinner-wrapper');

window.addEventListener('load', () => {
  setTimeout(() => {
    spinner.parentElement.removeChild(spinner);
    hero.classList.add('hero-animation');
  }, 500);
});

// Sidebar

burger.addEventListener('click', (e) => {
  burger.classList.toggle('burger-x');
  nav.classList.toggle('nav-open');
});
